module.exports = __webpack_public_path__ + "img/parking_detection.1078f05b.png";